export enum ApiMethodsEnum {
    Post = 'POST',
    Put = 'PUT',
    Get = 'GET',
    Delete = 'DELETE',
}
